import React from 'react';
import { BrowserRouter as Router, Link } from "react-router-dom";

export class Header extends React.Component {

	render() {
		return (
		<div className="header">
			<div className="logo">
				<a href="/"><span className="badge">&nbsp;&nbsp;r</span>ewardeclub</a>
			</div>
			<div className="menu-box" id="menu-box" onClick={this.toggleMenu}>
				<div className="menu-bar-1"></div>
				<div className="menu-bar-2"></div>
				<div className="menu-bar-3"></div>
			</div>

	      	<Router>
		      	<div className="menu-overlay" id="menu-overlay">
			        <Link className="menu-item" to="/about.html" target="_parent">How it works?</Link><br/>
			        <Link className="menu-item" to="/partner.html" target="_parent">Business Partners</Link><br/>
			        <Link className="menu-item" to="/customer.html" target="_parent">Customers</Link><br/>
			        <Link className="menu-item" to="/pricing.html" target="_parent">Pricing</Link><br/>
			        <Link className="menu-item" to="/contact.html" target="_parent">Contact</Link><br/>
		      	</div>
		    </Router>
        
	      	<Router>
		      	<div className="menu-row" id="menu-row">
			        <Link className="menu-item" to="/about.html" target="_parent">howItWorks?</Link>
			        <Link className="menu-item" to="/partner.html" target="_parent">businessPartners</Link>
			        <Link className="menu-item" to="/customer.html" target="_parent">customers</Link>
			        <Link className="menu-item" to="/pricing.html" target="_parent">pricing</Link>
			        <Link className="menu-item" to="/contact.html" target="_parent">contact</Link>
		      	</div>
		    </Router>
        
		</div>
		);
	}

	toggleMenu = () => {
		document.getElementById('menu-box').classList.toggle('change');
		document.getElementById('page').classList.toggle('hide');
		document.getElementById(this.props.overlay).classList.toggle('show');
	}
}




// WEBPACK FOOTER //
// ./src/components/Header.js